import YSelectFlag from './SelectFlag.vue';

export { YSelectFlag };
export default YSelectFlag;
